// Las frases de Configuración → Procesos que más de una tarjeta dice. Una copia
// por tarjeta sería la misma explicación redactada dos veces, y la que se
// editara primero dejaría a la otra mintiendo.

import type { StageBehavior } from './pipelines-data.js'

/** Por qué la tira del agente no tiene nada que enseñar cuando no hay agente.
 *  Se dice en lugar de dejar la tarjeta en blanco. */
export const GENERATE_NO_AGENT =
  'Necesitas un agente configurado para ver y publicar tu agente. Tu gerente de cuenta lo ' +
  'prepara contigo durante la activación.'

/** Cada comportamiento de etapa en las palabras de la fila. Las MISMAS que la
 *  lista de Etapas (`StageList`): la vista previa y la lista describen la misma
 *  etapa a cinco centímetros una de otra, y dos formas de nombrar un
 *  comportamiento son dos comportamientos para quien lee. `StageList` las
 *  importa de aquí desde F4-8: su copia privada era la otra mitad de este
 *  mismo problema. */
export const STAGE_BEHAVIOR_CHIP: Record<StageBehavior, string> = {
  inicio: 'Inicio',
  captura: 'Pregunta el Agente',
  agenda: 'Agenda la cita',
  multiplexor: 'Se ramifica',
  llenado_manual: 'La llena una persona',
  handoff: 'Pasa con una persona',
  fin: 'Termina el proceso',
}

export const STAGE_BEHAVIOR_TONE: Record<StageBehavior, 'draft' | 'info' | 'warn' | 'ok'> = {
  inicio: 'draft',
  captura: 'draft',
  agenda: 'info',
  multiplexor: 'draft',
  llenado_manual: 'info',
  handoff: 'warn',
  fin: 'ok',
}
